/**
 * A cloud location is where the Microsoft File Picker opens: the user's own
 * OneDrive, or a specific SharePoint site. (Glossary: "Cloud location" /
 * Danish "Placering". Distinct from a document's cloud *source*.)
 */
export type CloudLocation =
  | { kind: "oneDrive" }
  | {
      kind: "site";
      webUrl: string;
      displayName: string;
      /** Document library to open, relative to the site web (e.g. "Delte dokumenter"). */
      list?: string;
      /** Folder to open inside `list` (e.g. "Schultz dokumenter/Forretningsgange"). */
      folder?: string;
    };

export const ONE_DRIVE_LOCATION: CloudLocation = { kind: "oneDrive" };

/** A SharePoint site as listed by Graph or remembered by the API. */
export type SharePointSite = {
  webUrl: string;
  displayName: string;
};
